import UserProfilesApi from '@/api/userProfiles/';

import { setToken, getToken } from '@/utils'

export default {
    state: {
        userName: '',
        userId: '',
        l_id: '',
        avatarImgPath: '',
        token: getToken(),
        access: '',
        hasGetInfo: false,
        unreadCount: 0,
        messageUnreadList: [],
        messageReadedList: [],
        messageTrashList: [],
        messageContentStore: {},
        is_follow:false,//个人主页页面的 当前用户 是否已关注这个查看用户
        user_app_token:'',
    },
    mutations: {
        settoken(state, user_app_token) {
            state.user_app_token = user_app_token
            console.log('user_app_token',state)
        },
        setavatar(state, avatarPath) {
            state.avatarImgPath = avatarPath
        },
        setUserId(state, id) {
            state.userId = id
        },
        setlId(state, id) {
            state.l_id = id;
        },
        setUserName(state, name) {
            state.userName = name
        },
        setAccess(state, access) {
            state.access = access
        },
        setToken(state, token) {
            state.token = token
            setToken(token)
        },
        setHasGetInfo(state, status) {
            state.hasGetInfo = status
        },
        setMessageCount(state, count) {
            state.unreadCount = count
        },
        setMessageUnreadList(state, list) {
            state.messageUnreadList = list
        },
        setMessageReadedList(state, list) {
            state.messageReadedList = list
        },
        setMessageTrashList(state, list) {
            state.messageTrashList = list
        },
        updateMessageContentStore(state, { msg_id, content }) {
            state.messageContentStore[msg_id] = content
        },
        moveMsg(state, { from, to, msg_id }) {
            const index = state[from].findIndex(_ => _.msg_id === msg_id)
            const msgItem = state[from].splice(index, 1)[0]
            msgItem.loading = false
            state[to].unshift(msgItem)
        }
    },
    getters: {
        messageUnreadCount: state => state.messageUnreadList.length,
        messageReadedCount: state => state.messageReadedList.length,
        messageTrashCount: state => state.messageTrashList.length
    },
    actions: {
        // 登录
        handleLogin({ commit }, { email, password }) {
            email = email.trim()
            return new Promise((resolve, reject) => {
                login({
                    email,
                    password
                }).then(res => {
                    const data = res.data
                    commit('setToken', data.token)
                    resolve()
                }).catch(err => {
                    reject(err)
                })
            })
        },
        // 退出登录
        handleLogOut({ state, commit }) {
            return new Promise((resolve, reject) => {
                logout(state.token).then(() => {
                    commit('setToken', '')
                    commit('setAccess', [])
                    resolve()
                }).catch(err => {
                    reject(err)
                })
                // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
                // commit('setToken', '')
                // commit('setAccess', [])
                // resolve()
            })
        },
        // 获取用户相关信息
        getUserInfo({ state, commit }) {
            return new Promise((resolve, reject) => {
                try {
                    //获取个人主页t用户基础消息
                    // let userOpt = {user_id: 15493, user_type: 'user'}
                    UserProfilesApi.getUserInfoStatus().then(data => {
                        let res = {
                            "status": "success",
                            "code": "",
                            "message": "\u83b7\u53d6\u6210\u529f",
                            "data": {
                                "type": "igp",
                                "username": "UHURYVBJDKRUYGBC1540173294",
                                "passwd": "8e50e40badc4edca9cd8235124c3537f",
                                "email": "",
                                "phone": "qG5*****OghRtWQsxmS+iqvWA",
                                "phone_in_agreement": null,
                                "wx": "",
                                "avatar": "https://img.aigupiao.com/default_avatar/001.png",
                                "nickname": "这东西到能写多",
                                "brief": "",
                                "stock_list": "BK00295,sh603596,sh600519,sz301297,",
                                "futures_list": "",
                                "note": "",
                                "rec_time": "2018-10-22 09:54:54",
                                "up_time": "0000-00-00 00:00:00",
                                "rec_ip": "124.64.16.49",
                                "state": "",
                                "platform": "",
                                "add_v": "0",
                                "add_v_time": "-1",
                                "add_v_dec": "del_own",
                                "login_status": "61ef712ef9f60d5f72322e0116b78f1d",
                                "device_uid": "E206B797-2DB4-4561-A22A-978171E17B9F",
                                "stock_show": "yes",
                                "open_times": "1468",
                                "last_time": "2024-09-23 13:37:56",
                                "login_times": "205",
                                "last_login_time": "2024-09-18 10:43:52",
                                "install_cnl": "AppStore",
                                "curr_cnl": "AppStore",
                                "level": "11",
                                "level_reward": "8",
                                "experience": "3543",
                                "next_experience_differ": "997",
                                "guess_v": "no",
                                "view_self": "no",
                                "app_version": "1170",
                                "update_time": "2024-09-23 13:38:07",
                                "server_qa": "0",
                                "server_qa_gold": "15",
                                "home_page_view_range": "Week",
                                "all_show": "0",
                                "stock_ring_user": "0",
                                "cms_set_stock_show": "1",
                                "is_bind_phone": "yes",

                                "id": "44324",
                                "l_id": "46",
                                "user_app_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjI0NjI4OSIsImV4cCI6MTcyNzYwMjMyMSwiaXNzIjoiaWdwIiwic3ViIjoiMjQ2Mjg5In0.nbWUwatnICF3iD3GQETwBglPzJGsgr0SQIgsh86Jju4",

                                // "user_app_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjI0NjI4OSIsImV4cCI6MTcyNzMyOTc5MywiaXNzIjoiaWdwIiwic3ViIjoiMjQ2Mjg5In0.GTAlk632N9RHtqjbAOJWKVGMqpPR3X9PeCSQASWXpuw",
                                // "l_id": "0",
                                // "id": "246289",

                                "is_self": "yes",
                                "total_gold": "4720"
                              }
                        };
                        if(location.href.includes("192.168")){
                            //测试页面
                            data = res.data;
                        }
                        localStorage['Authorization'] = data.user_app_token;
                        console.log(data,'data123')
                        if (!data){
                            if(location.href.includes("/up/app/")&&!location.href.includes("192.168")){
                                // 未登录情况 跳转微信登录
                                function getQueryVariable(variable) {
                                    var query = window.location.search.substring(1);
                                    var vars = query.split("&");
                                    for (var i = 0; i < vars.length; i++) {
                                        var pair = vars[i].split("=");
                                        if (pair[0] == variable) { return pair[1]; }
                                    }
                                    return (false);
                                }
                                let l_id = getQueryVariable('l_id')
                                location.href = `/login/wx_login.html?login_type=server_promotion_wx_login&l_id=${l_id}`;
                            }                            
                            return false;
                        } 
                        

                        commit('setHasGetInfo', true)
                        data.avatar = data.avatar
                        data.name = data.nickname
                        data.access = "1"
                        data.token = "Bearer " + data.user_app_token;
                        data.user_id = data.id;
                        data.l_id = data.l_id;
                        data.userInfo = data;
                        commit('setavatar', data.avatar)
                        commit('settoken', data.user_app_token)
                        commit('setUserName', data.name)
                        commit('setUserId', data.id)
                        commit('setlId', data.l_id)
                        commit('setAccess', data.access)
                        console.info('[a12??')
                        
                        resolve(data)

                        console.log('resolve(data)')

                        //console.log(callback,'callback')

                        //callback && callback(data);
                    }).catch(err => {
                        reject(err)
                        console.log(err)
                    })
                } catch (error) {
                    reject(error)
                }
            })
        },
        // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
        getUnreadMessageCount({ state, commit }) {
            // getUnreadCount().then(res => {
            //   const { data } = res
            //   commit('setMessageCount', data)
            // })
        },
        // 获取消息列表，其中包含未读、已读、回收站三个列表
        getMessageList({ state, commit }) {
            return new Promise((resolve, reject) => {
                getMessage().then(res => {
                    const { unread, readed, trash } = res.data
                    commit('setMessageUnreadList', unread.sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
                    commit('setMessageReadedList', readed.map(_ => {
                        _.loading = false
                        return _
                    }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
                    commit('setMessageTrashList', trash.map(_ => {
                        _.loading = false
                        return _
                    }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 根据当前点击的消息的id获取内容
        getContentByMsgId({ state, commit }, { msg_id }) {
            return new Promise((resolve, reject) => {
                let contentItem = state.messageContentStore[msg_id]
                if (contentItem) {
                    resolve(contentItem)
                } else {
                    getContentByMsgId(msg_id).then(res => {
                        const content = res.data
                        commit('updateMessageContentStore', { msg_id, content })
                        resolve(content)
                    })
                }
            })
        },
        // 把一个未读消息标记为已读
        hasRead({ state, commit }, { msg_id }) {
            return new Promise((resolve, reject) => {
                hasRead(msg_id).then(() => {
                    commit('moveMsg', {
                        from: 'messageUnreadList',
                        to: 'messageReadedList',
                        msg_id
                    })
                    commit('setMessageCount', state.unreadCount - 1)
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 删除一个已读消息到回收站
        removeReaded({ commit }, { msg_id }) {
            return new Promise((resolve, reject) => {
                removeReaded(msg_id).then(() => {
                    commit('moveMsg', {
                        from: 'messageReadedList',
                        to: 'messageTrashList',
                        msg_id
                    })
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 还原一个已删除消息到已读消息
        restoreTrash({ commit }, { msg_id }) {
            return new Promise((resolve, reject) => {
                restoreTrash(msg_id).then(() => {
                    commit('moveMsg', {
                        from: 'messageTrashList',
                        to: 'messageReadedList',
                        msg_id
                    })
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}